import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from "@angular/router";
import { AdminRequestDto, AdminResponseDto, AdminService } from 'src/generated_client';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';

@Component({
  selector: 'app-editar-admin',
  templateUrl: './editar-admin.component.html',
  styleUrls: ['./editar-admin.component.css']
})
export class EditarAdminComponent implements OnInit {

  emailFormat = "[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}";
  adminResponse: AdminResponseDto = {} as AdminResponseDto;
  adminRequest: AdminRequestDto = {} as AdminRequestDto;

  editarAdmForm: FormGroup = this.fb.group({

    dsName: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, Validators.maxLength(35), Validators.minLength(3)])],
    dsEmail: ['', Validators.compose([Validators.pattern(this.emailFormat), Validators.required, Validators.maxLength(45)])],
    dsUsername: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, Validators.maxLength(30), Validators.minLength(2)])],
    logo: [''],
    newLogo: [''],
    dsCurrency: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, Validators.maxLength(15), Validators.minLength(1), Validators.pattern("^[^0-9]+$")])],
    dsSmsApi: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, Validators.maxLength(30), Validators.minLength(1)])],
    dsFb: [''],
    dsInsta: [''],
    dsTwitter: [''],
    dsYoutube: [''],
    dsPassword: ['', [Validators.required]],
  })

  constructor(
    private fb: FormBuilder,
    public adminService: AdminService,
    public authService: AuthService,
    private snackBar: SnackBarService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.adminResponse = this.authService.currentUser();
    this.adminService.apiAdminGetOneGet(this.adminResponse.cdAdmin).subscribe(x => {
      this.editarAdmForm.controls['dsName'].setValue(x.dsName)
      this.editarAdmForm.controls['dsEmail'].setValue(x.dsEmail),
        this.editarAdmForm.controls['dsUsername'].setValue(x.dsUsername),
        this.editarAdmForm.controls['logo'].setValue(x.dsLogo),
        this.editarAdmForm.controls['newLogo'].setValue(x.dsLogo),
        this.editarAdmForm.controls['dsCurrency'].setValue(x.dsCurrency),
        this.editarAdmForm.controls['dsSmsApi'].setValue(x.dsSmsApi),
        this.editarAdmForm.controls['dsFb'].setValue(x.dsFb),
        this.editarAdmForm.controls['dsInsta'].setValue(x.dsInsta),
        this.editarAdmForm.controls['dsTwitter'].setValue(x.dsTwitter),
        this.editarAdmForm.controls['dsYoutube'].setValue(x.dsYoutube)
    });
  }

  saveChanges(form: any) {
    this.adminRequest = { dsUsername: form.dsUsername, dsPassword: form.dsPassword }
    let result = this.adminService.apiAdminConfirmPost(this.adminRequest).subscribe(response => {
      if (result) {
        this.adminService.apiAdminPutPutForm(this.adminResponse.cdAdmin, form.dsName, form.dsEmail, form.dsUsername, undefined, form.logo,
          form.dsFb, form.dsInsta, form.dsTwitter, form.dsYoutube, form.dsSmsApi, form.dsCurrency).subscribe(() => {
            this.router.navigate(['admin-home']);
            this.snackBar.openSnackBar('Los cambios fueron guardados', 'Aceptar')
          },
            err => {
              this.snackBar.openSnackBar("Ocurrió un problema y los cambios no pudieron guardarse", 'Aceptar')
            }
          )
      }
    }, err => {
      this.snackBar.openSnackBar('Contraseña incorrecta', 'Aceptar')
    });
  };

  get DsImage() {
    return this.editarAdmForm.controls['newLogo'].value;
  }
}
